module.exports = __webpack_public_path__ + "img/pipe.6179babe.png";